import {useQuery} from '@tanstack/react-query';

import {getExternalParticipants} from '../api';
import {Participant} from '../types';

export const useGetExternalParticipants = (externalIds: string[]) => {
  return useQuery<Participant[]>({
    queryKey: ['externalParticipants', externalIds],
    queryFn: () => getExternalParticipants(externalIds),
    enabled: externalIds.length > 0,
  });
};
